import React from 'react';
import './Sponsors.css';

const Sponsors = () => {
  // Example sponsor data - in a real app, this would come from an API
  const sponsors = [
    {
      id: 1,
      name: 'Golf Pro Shop',
      tier: 'Platinum',
      logo: '🏌️',
      description: 'Premier golf equipment and apparel',
    },
    {
      id: 2,
      name: 'Green Valley Country Club',
      tier: 'Gold',
      logo: '⛳',
      description: 'Exclusive country club and course management',
    },
    {
      id: 3,
      name: 'Sports Equipment Co.',
      tier: 'Silver',
      logo: '🎯',
      description: 'Quality sports equipment for all your needs',
    },
    {
      id: 4,
      name: 'Local Business Partners',
      tier: 'Bronze',
      logo: '🤝',
      description: 'Supporting local golf community',
    },
  ];

  const getTierColor = (tier) => {
    const colors = {
      Platinum: '#e8e8e8',
      Gold: '#ffd700',
      Silver: '#c0c0c0',
      Bronze: '#cd7f32',
    };
    return colors[tier] || '#666';
  };

  return (
    <div className="sponsors">
      <h1>Our Sponsors</h1>
      <p className="sponsors-intro">
        We are grateful to our sponsors for their continued support of our golf
        tournaments and events.
      </p>

      <div className="sponsors-grid">
        {sponsors.map((sponsor) => (
          <div key={sponsor.id} className="sponsor-card">
            <div className="sponsor-logo">{sponsor.logo}</div>
            <div className="sponsor-info">
              <h3>{sponsor.name}</h3>
              <span
                className="sponsor-tier"
                style={{ color: getTierColor(sponsor.tier) }}
              >
                {sponsor.tier} Sponsor
              </span>
              <p>{sponsor.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sponsors;

